export const MOBILE_EDITABLE_MEDIA = "(max-width: 760px), (hover: none) and (pointer: coarse)";

interface MediaQueryTarget {
  matchMedia(query: string): { matches: boolean };
}

/** Avoid programmatic focus while mobile browsers are adjusting their viewport. */
export function shouldAutoFocusEditable(
  target: MediaQueryTarget | null = typeof window === "undefined" ? null : window
): boolean {
  return target !== null && !target.matchMedia(MOBILE_EDITABLE_MEDIA).matches;
}
